import {ThemeOptions} from "@material-ui/core/styles/createMuiTheme";

import {IWidgetPalette} from "app/services/theme/theme.types";
import {TypographyOptions} from "@material-ui/core/styles/createTypography";

export enum themeTypes {
  outlinedLight = 'outlined-light',
  outlinedDark = 'outlined-dark',
  light = 'light',
  dark = 'dark'
}

export enum modeType {
  normal = 'normal',
  preview = 'preview'
}

export enum bannerType {
  hidden = 'hidden' // @todo: save into diary and back end as a new query string parameter so that links will include it. severity: high
}

export enum wrapperStyleType {
  narrow = 'narrow',
  stacked = 'stacked',
  standard = 'standard',
  wide = 'wide'
}

export interface IWidgetTypography extends TypographyOptions {
  fontFamily?: string;
}

export interface IWidgetTheme extends ThemeOptions {
  type: themeTypes;
  defaultColors: boolean;
  typography?: IWidgetTypography;
  palette?: IWidgetPalette;
}

export interface IAnalyticsKeys {
  facebookApi: string;
  googleApi: string;
}

export enum blockNavType {
  becauseOfPayment = 1,
  becauseOfCoversPending = 2
}


export interface IAppQueryStringParams {
  mode?: modeType;
  colors?: string; // interchangable with 'accent'
  accent?: string; // interchangable with 'colors'
  font?: string;
  theme?: string;
  accountid: string;
  venueid?: string;
  fromurl?: string;
  bookingid: string;
  token?: string;
  date?: string;
  serviceids?: string;
  covers?: string;
  source?: string;
  debug?: string;
  bg?: string;
  banner?: string;
}
